import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings_/workflows/$id')({
  component: WorkflowDefinitionDetailLayout,
})

function WorkflowDefinitionDetailLayout() {
  return <Outlet />
}
